import moment from "moment";
import { useTranslation } from "react-i18next";
import { formatCurrency, renderPDFImage } from "../../helper";

interface FieldBlockProps {
  label: string;
  value: any;
  date?: boolean;
  price?: boolean;
  image?: boolean;
}

const DATE_FORMAT = "MMMM Do, YYYY";

const FieldBlock = ({ label, value, date, price, image }: FieldBlockProps) => {
  const { t } = useTranslation();
  if (date) {
    value = value ? moment(value).format(DATE_FORMAT) : "-";
  } else if (price) {
    value = value ? formatCurrency(value) : "-";
  }

  return (
    <div className="grid grid-cols-2">
      <p className="font-medium text-black text-sm">{t(label)}</p>
      {image ? (
        renderPDFImage(value)
      ) : (
        <p className="text-sm">{value || "-"}</p>
      )}
    </div>
  );
};

export default FieldBlock;
